import React, { useState } from "react"

import Header from "../../../../design-system/header"
import Paragraph from "../../../../design-system/paragraph"
import NewsletterEmailForm from "../../../../shared-components/layout/footer/newsletter-email-form"
import * as styles from "./index.module.scss"

function SidebarNewsletterCta() {
  const [showConfirmation, setShowConfirmation] = useState(false)

  return (
    <div className={styles.container}>
      <Header variant="5" as="h3">
        Reward and incentive insights, right in your inbox
      </Header>
      {showConfirmation ? (
        <Paragraph variant="3">Thank you for subscribing!</Paragraph>
      ) : (
        <NewsletterEmailForm
          setShowConfirmation={setShowConfirmation}
          className={styles.form}
        />
      )}
    </div>
  )
}

export default SidebarNewsletterCta
